module.exports = __webpack_public_path__ + "img/index-banner.6f077ea3.png";